<div class="container" [style.width]="config.width" [style.height]="config.height">
  <h2 mat-dialog-title>{{ config.title }}</h2>

  <div mat-dialog-content class="content">
    <p *ngIf="config.description">{{ config.description }}</p>
    <ng-template #target></ng-template>
  </div>

  <div mat-dialog-actions class="buttons-container">
    <button mat-flat-button *ngIf="config.showCancelButton" (click)="cancel()">
      {{ config.cancelButton ? config.cancelButton.label : ('album.popup.cancel_button' | translate) }}
    </button>
    <button mat-flat-button [color]="config.saveButton?.isDanger ? 'warn' : 'primary'" (click)="save()" [disabled]="isDisabled()" *ngIf="config.showSaveButton">
      {{ config.saveButton ? config.saveButton.label : ('album.popup.ok_button' | translate) }}
    </button>
  </div>
</div>
